import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { commonImports } from '../shared/table-interface';
import { ScrolldDirective } from '../scrolld.directive';
import { AppointmentUiComponent } from '../appointment-ui/appointment-ui.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, take, map, Subject, takeUntil } from 'rxjs';
import { Bundle, Task, SupplyDelivery } from 'fhir/r4';
import { backendEndPointToken } from '../app.config';
import { AddSupplyDeliveryComponent } from '../add-supply-delivery/add-supply-delivery.component';
import { EmptyStateComponent } from '../shared/empty-state/empty-state.component';
import { baseStatusStyles } from '../shared/statusUIIcons';
import { MatTableDataSource } from '@angular/material/table';
import { LinkInReferencesService } from '../shared/link-in-references.service';
import { AuthService } from '../shared/auth/auth.service';
import { TaskDetailsComponent } from '../tasks/task-details/task-details.component';
import { fetchFromReferencePipe } from '../shared/Fetch.pipe';
import { MatCardModule } from '@angular/material/card';
import { UpcomingActivitiesComponent } from '../unified-activities/upcoming-activities.component';

@Component({
  selector: 'app-lab-dashboard',
  imports: [
    ...commonImports,
    ScrolldDirective,
    AppointmentUiComponent,
    EmptyStateComponent,
    fetchFromReferencePipe,
    MatCardModule,
    UpcomingActivitiesComponent
  ],
  templateUrl: './lab-dashboard.component.html',
  styleUrls: ['../admin-dashboard/admin-dashboard.component.scss', './lab-dashboard.component.scss']
})
export class LabDashboardComponent implements OnInit, OnDestroy {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private http = inject(HttpClient);
  private backendEndPoint = inject(backendEndPointToken);
  private islink = inject(LinkInReferencesService);
  private authService = inject(AuthService);
  private destroy$ = new Subject<void>();

  statusStyles = baseStatusStyles;
  tableDataSource = new MatTableDataSource<any>();
  tableDataLevel2 = new BehaviorSubject<any[]>([]);
  tableColumns: string[] = ['type', 'for', 'status', 'actions'];
  isLinkObj: { [key: string]: Map<any, any> } = {};

  isLoadingTasks = true;
  tasks: Task[] = [];

  ngOnInit(): void {
    this.connectTableDataSource();
    this.loadTasks();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private connectTableDataSource(): void {
    this.tableDataSource.connect = () => this.tableDataLevel2;
  }

  private loadTasks(): void {
    const user = this.authService.user.getValue();
    let url = `${this.backendEndPoint}/Task?status=accepted,in-progress,ready&_count=50`;

    if (user?.fhirResourceId) {
      url += `&owner=Practitioner/${user.fhirResourceId}`;
    }

    this.http.get<Bundle<Task>>(url)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (bundle) => {
          const entries = bundle.entry || [];
          const resources = entries.map((e, index) => {
            const resource = e.resource as Task;
            for (const [key, value] of Object.entries(resource)) {
              if (!this.isLinkObj[key]) this.isLinkObj[key] = new Map();
              this.isLinkObj[key].set(index, this.islink.returnLinkFromReferences(value));
            }
            return resource;
          });

          this.tasks = resources;
          this.tableDataSource.data = resources;
          this.tableDataLevel2.next(resources);
          this.isLoadingTasks = false;
        },
        error: () => {
          this.isLoadingTasks = false;
        }
      });
  }

  addStock(): void {
    const ref = this.dialog.open(AddSupplyDeliveryComponent, {
      maxWidth: '650px',
      maxHeight: '90vh',
      width: '100%',
    });

    ref.afterClosed()
      .pipe(take(1))
      .subscribe((created: SupplyDelivery | undefined) => {
        // Optionally handle the created supply delivery
      });
  }

  goToTestRequests(): void {
    this.router.navigate(['/app/tests-requests']);
  }

  showTask(row: Task): void {
    this.dialog.open(TaskDetailsComponent, { data: row });
  }

  alltds(td: HTMLTableCellElement): void {
    const tdArr = Array.from(document.getElementsByTagName('td')) as HTMLElement[];
    tdArr.forEach(e => { e.parentElement!.style.zIndex = '99999'; });
    (td as HTMLElement).parentElement!.style.zIndex = '999999999999999999';
    (td as HTMLElement).parentElement!.style.overflow = 'visible';
  }
}
